import { createAction, props } from '@ngrx/store';
import { OrderItem } from '@shared/models/order-item';

export const loadOrderItemAudit = createAction(
  '[Orders] Load Order Item Audit Info',
  props<{ orderId: number; orderItemId: number }>(),
);

export const loadOrderItemAuditSuccess = createAction(
  '[Orders] Load Order Item Audit Info Success',
  props<{ orderItem: OrderItem }>(),
);

export const loadOrderItemAuditFailure = createAction(
  '[Orders] Load Order Item Audit Info Failure',
  props<{ error: any }>(),
);
